import { User } from '@bimdata/definitions/dto';

export default (u: User): string => {
  if (u.fullName === u.email) {
    return u.fullName;
  }
  return `${u.fullName} (${u.email})`;
}